"use client";

import { useMenuItem } from "../__chunks/MVIULMNR.js";
import { MenuItemCheckedContext, useMenuScopedContext } from "../__chunks/B2J376ND.js";
import "../__chunks/62UHHO2X.js";
import { useRadio } from "../__chunks/NLEBE274.js";
import "../__chunks/UVUMR3WP.js";
import "../__chunks/UQQRIHDV.js";
import "../__chunks/P2CTZE2T.js";
import "../__chunks/RZ4GPYOB.js";
import "../__chunks/KUU7WJ55.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/EM5CXX6A.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/LVA2YJMS.js";
import "../__chunks/SWN3JYXT.js";
import { createElement, createHook, forwardRef, memo } from "../__chunks/LMDWO4NN.js";
import "../__chunks/YV4JVR4I.js";
import { useInitialValue, useWrapElement } from "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/menu/menu-item-radio.tsx
import { invariant } from "@ariakit/core/utils/misc";
import { useEffect } from "react";
import { jsx } from "react/jsx-runtime";
var TagName = "div";
function getValue(prevValue, value, checked) {
  if (checked === void 0) return prevValue;
  if (checked) return value;
  return prevValue;
}
var useMenuItemRadio = createHook(function useMenuItemRadio2(_a) {
  var _b = _a,
    store = _b.store,
    name = _b.name,
    value = _b.value,
    checked = _b.checked,
    onChangeProp = _b.onChange,
    _b$hideOnClick = _b.hideOnClick,
    hideOnClick = _b$hideOnClick === void 0 ? false : _b$hideOnClick,
    props = __objRest(_b, ["store", "name", "value", "checked", "onChange", "hideOnClick"]);
  var context = useMenuScopedContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "MenuItemRadio must be wrapped in a MenuList or Menu component");
  var defaultChecked = useInitialValue(props.defaultChecked);
  useEffect(function () {
    store == null ? void 0 : store.setValue(name, function () {
      var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return getValue(prevValue, value, defaultChecked);
    });
  }, [store, name, value, defaultChecked]);
  useEffect(function () {
    if (checked === void 0) return;
    store == null ? void 0 : store.setValue(name, function (prevValue) {
      return getValue(prevValue, value, checked);
    });
  }, [store, name, value, checked]);
  var isChecked = store.useState(function (state) {
    return state.values[name] === value;
  });
  props = useWrapElement(props, function (element) {
    return /* @__PURE__ */jsx(MenuItemCheckedContext.Provider, {
      value: !!isChecked,
      children: element
    });
  }, [isChecked]);
  props = __spreadValues({
    role: "menuitemradio"
  }, props);
  props = useRadio(__spreadValues({
    name: name,
    value: value,
    checked: isChecked,
    onChange: function onChange(event) {
      onChangeProp == null ? void 0 : onChangeProp(event);
      if (event.defaultPrevented) return;
      var element = event.currentTarget;
      store == null ? void 0 : store.setValue(name, function (prevValue) {
        return getValue(prevValue, value, checked != null ? checked : element.checked);
      });
    }
  }, props));
  props = useMenuItem(__spreadValues({
    store: store,
    hideOnClick: hideOnClick
  }, props));
  return props;
});
var MenuItemRadio = memo(forwardRef(function MenuItemRadio2(props) {
  var htmlProps = useMenuItemRadio(props);
  return createElement(TagName, htmlProps);
}));
export { MenuItemRadio, useMenuItemRadio };